import { type PropsWithChildren } from 'react';
import { PipecatClient } from '@pipecat-ai/client-js';
import { DailyTransport } from '@pipecat-ai/daily-transport';
import { PipecatClientProvider } from '@pipecat-ai/client-react';

const transport = new DailyTransport();

const client = new PipecatClient({
  transport,
  enableMic: true,
  enableCam: false,
});

// Base URL for RTVI connection
// export const RTVI_BASE_URL = 'https://f5974a027deb.ngrok-free.app/connect';
// prod: 'https://amp-dev.dreamztesting.com/api/v1/campaigns/<campaign_slug>/start'

export function RTVIProvider({ children }: PropsWithChildren) {
  return <PipecatClientProvider client={client}>{children}</PipecatClientProvider>;
}